<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import HeroModule from '$src/js/modules/hero/HeroModule';
  import HeroSlider from '$src/js/components/molecules/hero-slider/HeroSlider.svelte';
  import HeroSkinSelector from '$src/js/components/molecules/hero-skin-selector/HeroSkinSelector.svelte';

  let videoWrapperEl = $state<HTMLDivElement>(undefined!);
  let videoEl = $state<HTMLImageElement>(undefined!);
  let canvasEl = $state<HTMLCanvasElement>(undefined!);
  let isPortrait = $state(typeof window !== 'undefined' && window.innerHeight > window.innerWidth);

  const videoSrc = $derived(
    isPortrait
      ? 'https://yellow-b-global.b-cdn.net/production/the-architect/images/bg-new-mobile.jpg?v=5'
      : 'https://yellow-b-global.b-cdn.net/production/the-architect/images/bg-new.jpg?v=5',
  );

  const handleResize = (): void => {
    isPortrait = window.innerHeight > window.innerWidth;
  };

  const handleSliderChange = (val: number): void => {
    HeroModule.getInstance().scene.setRotation(val);

    const targetPosX = ((val + 1) / 2) * 100;
    videoEl.style.objectPosition = `${String(targetPosX)}% 50%`;
  };

  const handleSkinChange = (index: 0 | 1): void => {
    HeroModule.getInstance().texture.setSkin(index);
  };

  onMount(() => {
    HeroModule.getInstance().intro.setVideoWrapperEl(videoWrapperEl);
    HeroModule.getInstance().scene.initialize(canvasEl);
    window.addEventListener('resize', handleResize);
  });

  onDestroy(() => {
    window.removeEventListener('resize', handleResize);
    HeroModule.getInstance().dispose();
  });
</script>

<div class="hero">
  <div class="video-wrapper" bind:this={videoWrapperEl}>
    <!-- <video
      bind:this={videoEl}
      src={videoSrc}
      autoplay
      loop
      muted
      playsinline
      class="background-video"
    ></video> -->

    <img src={videoSrc} bind:this={videoEl} alt="background" class="background-video" />
  </div>

  <canvas bind:this={canvasEl} class="scene-canvas"></canvas>

  <div class="controls">
    <div class="controls-content">
      <HeroSkinSelector onchange={handleSkinChange} />
      <HeroSlider onchange={handleSliderChange} />
    </div>
  </div>
</div>

<style>
  @reference '$src/css/main.css';

  .hero {
    @apply relative h-[calc(var(--vh)*100)] w-svw overflow-hidden bg-black sm:h-svh;
  }

  .controls {
    @apply absolute bottom-32 left-1/2 z-10 w-full -translate-x-1/2 lg:bottom-14 2xl:bottom-[8svh];
    @apply after:pointer-events-none after:absolute after:top-1/2 after:-right-10 after:-left-10 after:z-[-1] after:h-110 after:-translate-y-1/2 after:rotate-180 after:bg-[radial-gradient(50%_50%_at_50%_100%,rgba(0,0,0,0)_99.99%,rgba(0,0,0,0.5)_100%)] after:opacity-80 after:blur-2xl after:content-[''];
  }

  /* .hero:after {
    content: '';
    position: absolute;
    inset: -50%;
    width: 200%;
    height: 200%;
    z-index: 10;
    pointer-events: none;
    background-image: url('/images/white-noise-screen.png');
    background-size: 256px 256px;
    opacity: 0.05;
    mix-blend-mode: overlay;
    will-change: transform;
    animation: grain-shift 0.1s steps(5) infinite;
  } */

  .video-wrapper {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .background-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
  }

  .scene-canvas {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    display: block;
    pointer-events: none;
  }

  @keyframes grain-shift {
    0% {
      transform: translate(0, 0);
    }
    25% {
      transform: translate(10%, -10%);
    }
    50% {
      transform: translate(-10%, -10%);
    }
    75% {
      transform: translate(-10%, 10%);
    }
    100% {
      transform: translate(5%, 5%);
    }
  }
</style>
